import {
    CARGAR_CENTROS,
    CARGAR_CENTROS_EXITO,
    CARGAR_CENTROS_ERROR,

    CARGAR_LIQUIDACION_CENTRO,
    CARGAR_LIQUIDACION_CENTRO_EXITO,
    CARGAR_LIQUIDACION_CENTRO_ERROR,

    CARGAR_RESUMEN_CENTROS,
    CARGAR_RESUMEN_CENTROS_EXITO,
    CARGAR_RESUMEN_CENTROS_ERROR,

    CARGAR_ACUERDOS_CENTRO,
    CARGAR_ACUERDOS_CENTRO_EXITO,
    CARGAR_ACUERDOS_CENTRO_ERROR,

    CREAR_ACUERDO_CENTRO,
    CREAR_ACUERDO_CENTRO_EXITO,
    CREAR_ACUERDO_CENTRO_ERROR,

    ACTUALIZAR_ACUERDO_CENTRO,
    ACTUALIZAR_ACUERDO_CENTRO_EXITO,
    ACTUALIZAR_ACUERDO_CENTRO_ERROR,

    CERRAR_ACUERDO_CENTRO,
    CERRAR_ACUERDO_CENTRO_EXITO,
    CERRAR_ACUERDO_CENTRO_ERROR,

    CARGAR_CONFIGURACIONES_CENTRO,
    CARGAR_CONFIGURACIONES_CENTRO_EXITO,
    CARGAR_CONFIGURACIONES_CENTRO_ERROR,

    CREAR_CONFIGURACION_CENTRO,
    CREAR_CONFIGURACION_CENTRO_EXITO,
    CREAR_CONFIGURACION_CENTRO_ERROR,

    CARGAR_POSICION_CENTRO,
    CARGAR_POSICION_CENTRO_EXITO,
    CARGAR_POSICION_CENTRO_ERROR,

    REGISTRAR_PAGO_CENTRO,
    REGISTRAR_PAGO_CENTRO_EXITO,
    REGISTRAR_PAGO_CENTRO_ERROR,

    CARGAR_PAGOS_CENTRO,
    CARGAR_PAGOS_CENTRO_EXITO,
    CARGAR_PAGOS_CENTRO_ERROR,

    ANULAR_PAGO_CENTRO,
    ANULAR_PAGO_CENTRO_EXITO,
    ANULAR_PAGO_CENTRO_ERROR,

    CAMBIAR_PAGAR_PRESTACION_CENTRO,
    CAMBIAR_PAGAR_PRESTACION_CENTRO_EXITO,
    CAMBIAR_PAGAR_PRESTACION_CENTRO_ERROR,

    CERRAR_SESION
} from '../types';


/*
====================================
ESTADO INICIAL
====================================

La información de Centros se mantiene
en Redux durante toda la sesión.

La caché evita repetir consultas que
ya fueron realizadas.

Se limpia completamente al cerrar
sesión.
====================================
*/

const initialState = {

    cargandoCentros:
        false,

    cargandoLiquidacion:
        false,

    cargandoResumen:
        false,

    cargandoAcuerdosCentro:
        false,

    guardandoAcuerdoCentro:
        false,

    guardandoCondicionesAcuerdoCentro:
        false,

    cerrandoAcuerdoCentro:
        false,

    cargandoConfiguracionesCentro:
        false,

    guardandoConfiguracionCentro:
        false,

    cargandoPosicionCentro:
        false,

    registrandoPagoCentro:
        false,

    guardandoCondicionPrestacionCentro:
        false,

    posicionCentro:
        null,

    posicionCentroActualKey:
        null,

    posicionCentroCache:
        {},

    cargandoPagosCentro:
        false,

    anulandoPagoCentro:
        false,

    pagosCentro:
        [],

    pagosCentroActualKey:
        null,

    pagosCentroCache:
        {},

    configuracionesCentro:
        [],

    configuracionesCentroActualId:
        null,

    configuracionesCentroCache:
        {},

    error:
        null,


    /*
    ====================================
    CENTROS
    ====================================
    */

    centros:
        [],

    centrosCargados:
        false,


    /*
    ====================================
    LIQUIDACIÓN INDIVIDUAL
    ====================================
    */

    liquidacion:
        null,

    liquidacionActualKey:
        null,

    liquidacionesCache:
        {},


    /*
    ====================================
    RESUMEN DE CENTROS
    ====================================
    */

    resumenCentros:
        [],

    resumenActualKey:
        null,

    resumenCentrosCache:
        {},


    /*
    ====================================
    ACUERDOS DEL CENTRO
    ====================================

    acuerdosCentro:
    acuerdos del centro que actualmente
    estamos mostrando.

    acuerdosCentroCache:
    conserva los acuerdos ya consultados
    para no repetir requests al cambiar
    entre centros.
    ====================================
    */

    acuerdosCentro:
        [],

    acuerdosCentroActualId:
        null,

    acuerdosCentroCache:
        {}

};


/*
====================================
REDUCER
====================================
*/

export default function centrosLiquidacionesReducer(
    state = initialState,
    action
) {

    switch (action.type) {


        /*
        ====================================
        CARGAR CENTROS
        ====================================
        */

        case CARGAR_CENTROS:

            return {

                ...state,

                cargandoCentros:
                    true,

                error:
                    null

            };


        case CARGAR_CENTROS_EXITO: {

            const centros =

                Array.isArray(
                    action.payload?.centros
                )

                    ? action.payload.centros

                    : Array.isArray(
                        action.payload
                    )

                        ? action.payload

                        : [];


            return {

                ...state,

                cargandoCentros:
                    false,

                error:
                    null,

                centros,

                centrosCargados:
                    true

            };

        }


        case CARGAR_CENTROS_ERROR:

            return {

                ...state,

                cargandoCentros:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudieron cargar los centros.'
                    }

            };


        /*
        ====================================
        CARGAR LIQUIDACIÓN INDIVIDUAL
        ====================================
        */

        case CARGAR_LIQUIDACION_CENTRO:

            return {

                ...state,

                cargandoLiquidacion:
                    true,

                error:
                    null,

                liquidacionActualKey:
                    action.payload ||
                    null,

                liquidacion:
                    state.liquidacionActualKey ===
                        action.payload

                        ? state.liquidacion

                        : null

            };


        case CARGAR_LIQUIDACION_CENTRO_EXITO: {

            const clave =
                action.payload?.clave ||
                null;


            const liquidacion =
                action.payload?.data ||
                null;


            const centroId =

                liquidacion
                    ?.centro_id !==
                undefined &&

                liquidacion
                    ?.centro_id !==
                null

                    ? String(
                        liquidacion
                            .centro_id
                    )

                    : null;


            const moneda =

                liquidacion
                    ?.moneda ||

                'ARS';


            /*
            ====================================
            ACTUALIZAR FILA DEL RESUMEN
            ====================================

            La liquidación individual contiene
            los números más nuevos del centro.

            Aprovechamos esa respuesta para
            actualizar solamente su fila dentro
            del resumen general.

            No copiamos detalle_prestaciones
            dentro del resumen porque el detalle
            queda en liquidacionesCache.
            ====================================
            */

            const actualizarResumen = (
                lista
            ) => {

                if (
                    !Array.isArray(
                        lista
                    ) ||
                    !centroId ||
                    !liquidacion
                ) {

                    return Array.isArray(
                        lista
                    )

                        ? lista

                        : [];

                }


                return lista.map(
                    (item) => {

                        if (
                            String(
                                item
                                    ?.centro
                                    ?.id
                            ) !==
                            centroId
                        ) {

                            return item;

                        }


                        return {

                            ...item,

                            liquidacion: {

                                ...(
                                    item
                                        ?.liquidacion ||
                                    {}
                                ),


                                centro_id:
                                    liquidacion
                                        .centro_id,


                                moneda:
                                    liquidacion
                                        .moneda ||
                                    item
                                        ?.liquidacion
                                        ?.moneda ||
                                    'ARS',


                                periodo:

                                    liquidacion
                                        .periodo ||

                                    item
                                        ?.liquidacion
                                        ?.periodo ||

                                    null,


                                resumen:

                                    liquidacion
                                        .resumen ||

                                    item
                                        ?.liquidacion
                                        ?.resumen ||

                                    {},


                                alertas:

                                    liquidacion
                                        .alertas ||

                                    item
                                        ?.liquidacion
                                        ?.alertas ||

                                    {
                                        mensuales_cobro_requieren_reprocesamiento:
                                            []
                                    }

                            }

                        };

                    }
                );

            };


            const resumenCentrosActualizado =
                actualizarResumen(
                    state.resumenCentros
                );


            /*
            ====================================
            ACTUALIZAR TAMBIÉN LA CACHÉ
            DEL RESUMEN ACTUAL
            ====================================
            */

            const resumenCentrosCache = {

                ...state
                    .resumenCentrosCache

            };


            if (
                state.resumenActualKey &&
                Array.isArray(
                    resumenCentrosCache[
                        state.resumenActualKey
                    ]
                )
            ) {

                resumenCentrosCache[
                    state.resumenActualKey
                ] =
                    actualizarResumen(
                        resumenCentrosCache[
                            state.resumenActualKey
                        ]
                    );

            }


            /*
            ====================================
            POSICIÓN GLOBAL
            ====================================

            La liquidación individual YA devuelve:

            posicion_actual

            Por eso no necesitamos hacer además
            /traerposicioncentro.
            ====================================
            */

            const posicion =
                liquidacion
                    ?.posicion_actual ||
                null;


            const clavePosicion =

                centroId

                    ? `${centroId}|${moneda}`

                    : null;


            const posicionCentroCache = {

                ...state
                    .posicionCentroCache

            };


            if (
                clavePosicion &&
                posicion
            ) {

                posicionCentroCache[
                    clavePosicion
                ] =
                    posicion;

            }


            return {

                ...state,


                /*
                ====================================
                LIQUIDACIÓN DETALLADA
                ====================================
                */

                cargandoLiquidacion:
                    false,


                error:
                    null,


                liquidacion,


                liquidacionActualKey:
                    clave,


                liquidacionesCache: {

                    ...state
                        .liquidacionesCache,


                    ...(clave

                        ? {
                            [clave]:
                                liquidacion
                        }

                        : {}
                    )

                },


                /*
                ====================================
                RESUMEN GENERAL
                ====================================
                */

                resumenCentros:
                    resumenCentrosActualizado,


                resumenCentrosCache,


                /*
                ====================================
                POSICIÓN GLOBAL
                ====================================
                */

                ...(
                    clavePosicion &&
                    posicion

                        ? {

                            cargandoPosicionCentro:
                                false,


                            posicionCentro:
                                posicion,


                            posicionCentroActualKey:
                                clavePosicion,


                            posicionCentroCache

                        }

                        : {}
                )

            };

        }


        case CARGAR_LIQUIDACION_CENTRO_ERROR:

            return {

                ...state,

                cargandoLiquidacion:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudo cargar la liquidación del centro.'
                    }

            };


        /*
        ====================================
        CARGAR RESUMEN DE CENTROS
        ====================================
        */

        case CARGAR_RESUMEN_CENTROS:

            return {

                ...state,

                cargandoResumen:
                    true,

                error:
                    null,

                resumenActualKey:
                    action.payload ||
                    null,

                resumenCentros:
                    state.resumenActualKey ===
                        action.payload

                        ? state.resumenCentros

                        : []

            };


        case CARGAR_RESUMEN_CENTROS_EXITO: {

            const clave =
                action.payload?.clave ||
                null;


            const resultados =

                Array.isArray(
                    action.payload?.data
                )

                    ? action.payload.data

                    : [];


            const liquidacionesCache = {

                ...state.liquidacionesCache

            };


            resultados.forEach(
                (item) => {

                    if (
                        item?.claveLiquidacion &&
                        item?.liquidacion
                    ) {

                        liquidacionesCache[
                            item.claveLiquidacion
                        ] =
                            item.liquidacion;

                    }

                }
            );


            return {

                ...state,

                cargandoResumen:
                    false,

                error:
                    null,

                resumenCentros:
                    resultados,

                resumenActualKey:
                    clave,

                resumenCentrosCache: {

                    ...state.resumenCentrosCache,

                    ...(clave
                        ? {
                            [clave]:
                                resultados
                        }
                        : {}
                    )

                },

                liquidacionesCache

            };

        }


        case CARGAR_RESUMEN_CENTROS_ERROR:

            return {

                ...state,

                cargandoResumen:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudo cargar el resumen de centros.'
                    }

            };


        /*
        ====================================
        CARGAR ACUERDOS DEL CENTRO
        ====================================
        */

        case CARGAR_ACUERDOS_CENTRO: {

            const centroId =
                action.payload
                    ? String(
                        action.payload
                    )
                    : null;


            return {

                ...state,

                cargandoAcuerdosCentro:
                    true,

                error:
                    null,

                acuerdosCentroActualId:
                    centroId,

                acuerdosCentro:

                    state
                        .acuerdosCentroActualId ===
                        centroId

                        ? state.acuerdosCentro

                        : (
                            state
                                .acuerdosCentroCache
                                ?.[centroId] ||
                            []
                        )

            };

        }


        case CARGAR_ACUERDOS_CENTRO_EXITO: {

            const centroId =

                action.payload
                    ?.centro_id !==
                    undefined &&
                action.payload
                    ?.centro_id !==
                    null

                    ? String(
                        action.payload
                            .centro_id
                    )

                    : null;


            const acuerdos =

                Array.isArray(
                    action.payload?.data
                )

                    ? action.payload.data

                    : [];


            return {

                ...state,

                cargandoAcuerdosCentro:
                    false,

                error:
                    null,

                acuerdosCentroActualId:
                    centroId,

                acuerdosCentro:
                    acuerdos,

                acuerdosCentroCache: {

                    ...state.acuerdosCentroCache,

                    ...(centroId
                        ? {
                            [centroId]:
                                acuerdos
                        }
                        : {}
                    )

                }

            };

        }


        case CARGAR_ACUERDOS_CENTRO_ERROR:

            return {

                ...state,

                cargandoAcuerdosCentro:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudieron cargar los pacientes vinculados.'
                    }

            };


        /*
        ====================================
        CREAR ACUERDO
        ====================================
        */

        case CREAR_ACUERDO_CENTRO:

            return {

                ...state,

                guardandoAcuerdoCentro:
                    true,

                error:
                    null

            };


        case CREAR_ACUERDO_CENTRO_EXITO: {

            const centroId =

                action.payload
                    ?.centro_id !==
                    undefined &&
                action.payload
                    ?.centro_id !==
                    null

                    ? String(
                        action.payload
                            .centro_id
                    )

                    : null;


            const acuerdo =
                action.payload
                    ?.acuerdo ||
                null;


            if (
                !centroId ||
                !acuerdo
            ) {

                return {

                    ...state,

                    guardandoAcuerdoCentro:
                        false

                };

            }


            const acuerdosAnteriores =

                Array.isArray(
                    state
                        .acuerdosCentroCache
                        ?.[centroId]
                )

                    ? state
                        .acuerdosCentroCache[
                            centroId
                        ]

                    : [];


            const existe =
                acuerdosAnteriores.some(
                    (item) =>
                        String(
                            item.id
                        ) ===
                        String(
                            acuerdo.id
                        )
                );


            const nuevosAcuerdos =

                existe

                    ? acuerdosAnteriores.map(
                        (item) =>

                            String(
                                item.id
                            ) ===
                            String(
                                acuerdo.id
                            )

                                ? acuerdo

                                : item
                    )

                    : [
                        acuerdo,
                        ...acuerdosAnteriores
                    ];


            return {

                ...state,

                guardandoAcuerdoCentro:
                    false,

                error:
                    null,

                acuerdosCentroCache: {

                    ...state.acuerdosCentroCache,

                    [centroId]:
                        nuevosAcuerdos

                },

                acuerdosCentro:

                    String(
                        state
                            .acuerdosCentroActualId ||
                        ''
                    ) ===
                    centroId

                        ? nuevosAcuerdos

                        : state.acuerdosCentro

            };

        }


        case CREAR_ACUERDO_CENTRO_ERROR:

            return {

                ...state,

                guardandoAcuerdoCentro:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudo vincular el paciente al centro.'
                    }

            };

                /*
        ====================================
        ACTUALIZAR CONDICIONES DEL ACUERDO
        ====================================
        */

        case ACTUALIZAR_ACUERDO_CENTRO:

            return {

                ...state,

                guardandoCondicionesAcuerdoCentro:
                    true,

                error:
                    null

            };


        case ACTUALIZAR_ACUERDO_CENTRO_EXITO:

            return {

                ...state,

                guardandoCondicionesAcuerdoCentro:
                    false,

                error:
                    null

            };


        case ACTUALIZAR_ACUERDO_CENTRO_ERROR:

            return {

                ...state,

                guardandoCondicionesAcuerdoCentro:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudieron actualizar las condiciones del paciente.'
                    }

            };

        /*
        ====================================
        CERRAR ACUERDO CENTRO
        ====================================
        */

        case CERRAR_ACUERDO_CENTRO:

            return {

                ...state,

                cerrandoAcuerdoCentro:
                    true,

                error:
                    null

            };


        case CERRAR_ACUERDO_CENTRO_EXITO: {

            const centroId =
                String(
                    action.payload
                        ?.centro_id ||
                    ''
                );


            const acuerdoActualizado =
                action.payload
                    ?.acuerdo ||
                null;


            if (
                !centroId ||
                !acuerdoActualizado
            ) {

                return {

                    ...state,

                    cerrandoAcuerdoCentro:
                        false,

                    error:
                        null

                };

            }


            const actualizarLista = (
                lista
            ) => {

                const acuerdos =

                    Array.isArray(
                        lista
                    )

                        ? lista

                        : [];


                return acuerdos.map(
                    (acuerdo) =>

                        String(
                            acuerdo.id
                        ) ===
                        String(
                            acuerdoActualizado.id
                        )

                            ? acuerdoActualizado

                            : acuerdo
                );

            };


            const cacheActual =
                state
                    .acuerdosCentroCache ||
                {};


            const acuerdosCacheCentro =
                cacheActual[
                    centroId
                ] ||
                [];


            const esCentroActual =

                String(
                    state
                        .acuerdosCentroActualId ||
                    ''
                ) ===
                centroId;


            return {

                ...state,

                cerrandoAcuerdoCentro:
                    false,

                acuerdosCentroCache: {

                    ...cacheActual,

                    [centroId]:
                        actualizarLista(
                            acuerdosCacheCentro
                        )

                },

                acuerdosCentro:

                    esCentroActual

                        ? actualizarLista(
                            state.acuerdosCentro
                        )

                        : state.acuerdosCentro,

                error:
                    null

            };

        }


        case CERRAR_ACUERDO_CENTRO_ERROR:

            return {

                ...state,

                cerrandoAcuerdoCentro:
                    false,

                error:
                    action.payload ||
                    {
                        msg:
                            'No se pudo finalizar la vinculación del paciente.'
                    }

            };

        /*
        ====================================
        CARGAR CONFIGURACIONES DEL CENTRO
        ====================================
        */

        case CARGAR_CONFIGURACIONES_CENTRO: {

            const centroId =
                String(
                    action.payload ||
                    ''
                );


            return {

                ...state,

                cargandoConfiguracionesCentro:
                    true,

                configuracionesCentroActualId:
                    centroId,

                configuracionesCentro:

                    state
                        .configuracionesCentroCache
                        ?.[centroId] ||

                    [],

                error:
                    null

            };

        }


        case CARGAR_CONFIGURACIONES_CENTRO_EXITO: {

            const centroId =
                String(
                    action.payload
                        ?.centro_id ||
                    ''
                );


            const configuraciones =
                Array.isArray(
                    action.payload
                        ?.data
                )

                    ? action.payload.data

                    : [];


            return {

                ...state,

                cargandoConfiguracionesCentro:
                    false,

                configuracionesCentroActualId:
                    centroId,

                configuracionesCentro:
                    configuraciones,

                configuracionesCentroCache: {

                    ...state
                        .configuracionesCentroCache,

                    [centroId]:
                        configuraciones

                },

                error:
                    null

            };

        }


        case CARGAR_CONFIGURACIONES_CENTRO_ERROR:

            return {

                ...state,

                cargandoConfiguracionesCentro:
                    false,

                error:
                    action.payload

            };


        /*
        ====================================
        CREAR CONFIGURACIÓN
        ====================================
        */

        case CREAR_CONFIGURACION_CENTRO:

            return {

                ...state,

                guardandoConfiguracionCentro:
                    true,

                error:
                    null

            };


        case CREAR_CONFIGURACION_CENTRO_EXITO:

            return {

                ...state,

                guardandoConfiguracionCentro:
                    false,

                error:
                    null

            };


        case CREAR_CONFIGURACION_CENTRO_ERROR:

            return {

                ...state,

                guardandoConfiguracionCentro:
                    false,

                error:
                    action.payload

            };

    /*
    ====================================
    CARGAR POSICIÓN DEL CENTRO
    ====================================
    */

    case CARGAR_POSICION_CENTRO: {

        const clave =
            action.payload ||
            null;


        return {

            ...state,

            cargandoPosicionCentro:
                true,

            posicionCentroActualKey:
                clave,

            posicionCentro:

                clave &&
                state
                    .posicionCentroCache
                    ?.[clave]

                    ? state
                        .posicionCentroCache[
                            clave
                        ]

                    : null,

            error:
                null

        };

    }


    case CARGAR_POSICION_CENTRO_EXITO: {

        const clave =
            action.payload
                ?.clave ||
            null;


        const posicion =
            action.payload
                ?.data ||
            null;


        return {

            ...state,

            cargandoPosicionCentro:
                false,

            posicionCentroActualKey:
                clave,

            posicionCentro:
                posicion,

            posicionCentroCache: {

                ...state
                    .posicionCentroCache,

                ...(clave

                    ? {
                        [clave]:
                            posicion
                    }

                    : {}
                )

            },

            error:
                null

        };

    }


    case CARGAR_POSICION_CENTRO_ERROR:

        return {

            ...state,

            cargandoPosicionCentro:
                false,

            error:
                action.payload ||
                {
                    msg:
                        'No se pudo cargar la posición del centro.'
                }

        };


    /*
    ====================================
    REGISTRAR PAGO AL CENTRO
    ====================================
    */

    case REGISTRAR_PAGO_CENTRO:

        return {

            ...state,

            registrandoPagoCentro:
                true,

            error:
                null

        };


    case REGISTRAR_PAGO_CENTRO_ERROR:

        return {

            ...state,

            registrandoPagoCentro:
                false,

            error:
                action.payload ||
                {
                    msg:
                        'No se pudo registrar el pago al centro.'
                }

        };

    /*
    ====================================
    CARGAR PAGOS DEL CENTRO
    ====================================
    */

    case CARGAR_PAGOS_CENTRO: {

        const clave =
            action.payload ||
            null;


        return {

            ...state,

            cargandoPagosCentro:
                true,

            pagosCentroActualKey:
                clave,

            pagosCentro:

                clave &&
                state
                    .pagosCentroCache
                    ?.[clave]

                    ? state
                        .pagosCentroCache[
                            clave
                        ]

                    : [],

            error:
                null

        };

    }


    case CARGAR_PAGOS_CENTRO_EXITO: {

        const clave =
            action.payload
                ?.clave ||
            null;


        const pagos =
            Array.isArray(
                action.payload
                    ?.data
            )

                ? action.payload.data

                : [];


        const esActual =

            state
                .pagosCentroActualKey ===
            clave;


        return {

            ...state,

            cargandoPagosCentro:
                false,

            pagosCentro:

                esActual

                    ? pagos

                    : state
                        .pagosCentro,

            pagosCentroCache: {

                ...state
                    .pagosCentroCache,

                ...(clave

                    ? {
                        [clave]:
                            pagos
                    }

                    : {}
                )

            },

            error:
                null

        };

    }


    case CARGAR_PAGOS_CENTRO_ERROR:

        return {

            ...state,

            cargandoPagosCentro:
                false,

            error:
                action.payload

        };


    /*
    ====================================
    REGISTRAR PAGO - ACTUALIZAR HISTORIAL
    ====================================

    Reemplazá tu case actual
    REGISTRAR_PAGO_CENTRO_EXITO
    por este.
    ====================================
    */

    case REGISTRAR_PAGO_CENTRO_EXITO: {

        const resultado =
            action.payload ||
            {};


        const pago =
            resultado
                ?.pago ||
            null;


        if (
            !pago
        ) {

            return {

                ...state,

                registrandoPagoCentro:
                    false,

                error:
                    null

            };

        }


        const clave =
            `${String(
                pago.centro_id
            )}|${pago.moneda || 'ARS'}`;


        const cache =
            state
                .pagosCentroCache ||
            {};


        const historialYaCargado =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    clave
                );


        if (
            !historialYaCargado
        ) {

            return {

                ...state,

                registrandoPagoCentro:
                    false,

                error:
                    null

            };

        }


        const importeImputado =

            (
                Array.isArray(
                    resultado
                        .imputaciones
                )

                    ? resultado
                        .imputaciones

                    : []
            )
                .reduce(
                    (
                        total,
                        imputacion
                    ) =>

                        total +
                        Number(
                            imputacion
                                ?.importe ||
                            0
                        ),

                    0
                );


        const pagoNuevo = {

            ...pago,

            importe_imputado:
                importeImputado,

            saldo_disponible:
                Number(
                    resultado
                        ?.saldo_disponible ||
                    0
                )

        };


        const pagosActualizados = [

            pagoNuevo,

            ...(
                cache[
                    clave
                ] ||
                []
            )
                .filter(
                    (item) =>

                        String(
                            item.id
                        ) !==
                        String(
                            pago.id
                        )
                )

        ];


        return {

            ...state,

            registrandoPagoCentro:
                false,

            pagosCentroCache: {

                ...cache,

                [clave]:
                    pagosActualizados

            },

            pagosCentro:

                state
                    .pagosCentroActualKey ===
                    clave

                    ? pagosActualizados

                    : state
                        .pagosCentro,

            error:
                null

        };

    }


    /*
    ====================================
    ANULAR PAGO
    ====================================
    */

    case ANULAR_PAGO_CENTRO:

        return {

            ...state,

            anulandoPagoCentro:
                true,

            error:
                null

        };


    case ANULAR_PAGO_CENTRO_EXITO: {

        const clave =
            action.payload
                ?.clave ||
            null;


        const pagoActualizado =
            action.payload
                ?.pago ||
            null;


        if (
            !clave ||
            !pagoActualizado
        ) {

            return {

                ...state,

                anulandoPagoCentro:
                    false,

                error:
                    null

            };

        }


        const cache =
            state
                .pagosCentroCache ||
            {};


        const existeHistorial =
            Object.prototype
                .hasOwnProperty
                .call(
                    cache,
                    clave
                );


        if (
            !existeHistorial
        ) {

            return {

                ...state,

                anulandoPagoCentro:
                    false,

                error:
                    null

            };

        }


        const pagosActualizados =
            (
                cache[
                    clave
                ] ||
                []
            )
                .map(
                    (pago) =>

                        String(
                            pago.id
                        ) ===
                        String(
                            pagoActualizado.id
                        )

                            ? {

                                ...pago,

                                ...pagoActualizado

                            }

                            : pago
                );


        return {

            ...state,

            anulandoPagoCentro:
                false,

            pagosCentroCache: {

                ...cache,

                [clave]:
                    pagosActualizados

            },

            pagosCentro:

                state
                    .pagosCentroActualKey ===
                    clave

                    ? pagosActualizados

                    : state
                        .pagosCentro,

            error:
                null

        };

    }


    case ANULAR_PAGO_CENTRO_ERROR:

        return {

            ...state,

            anulandoPagoCentro:
                false,

            error:
                action.payload

        };

    /*
    ====================================
    CAMBIAR PAGAR / NO PAGAR
    PRESTACIÓN DEL CENTRO
    ====================================
    */

    case CAMBIAR_PAGAR_PRESTACION_CENTRO:

        return {

            ...state,

            guardandoCondicionPrestacionCentro:
                true,

            error:
                null

        };


    case CAMBIAR_PAGAR_PRESTACION_CENTRO_EXITO:

        return {

            ...state,

            guardandoCondicionPrestacionCentro:
                false,

            error:
                null

        };


    case CAMBIAR_PAGAR_PRESTACION_CENTRO_ERROR:

        return {

            ...state,

            guardandoCondicionPrestacionCentro:
                false,

            error:
                action.payload

        };

        /*
        ====================================
        CERRAR SESIÓN
        ====================================
        */

        case CERRAR_SESION:

            return initialState;


        default:

            return state;

    }

}